/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  const RELOAD_FLAG = 'wirechina-sw-reloaded'
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      console.log('Service worker has been registered.')
      // 注册后定时检查 SW 是否有新构建，确保离线后也能检测到新版本
      try {
        setInterval(async () => {
          const registration = await navigator.serviceWorker.getRegistration()
          if (registration) {
            registration.update().catch(() => {})
          }
        }, 10 * 60 * 1000) // 每 10 分钟检查一次
      } catch (_) {}
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(registration) {
      console.log('New content is available; please refresh.')
      // 避免刷新后 updated 再次命中形成死循环
      try {
        if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
          sessionStorage.removeItem(RELOAD_FLAG)
          return
        }
        sessionStorage.setItem(RELOAD_FLAG, '1')
      } catch (_) {}
      // 新 SW 已激活且已通过 workbox clientsClaim 接管页面，此时强制刷新加载新资源
      // 不使用 cache: reload，避免老浏览器兼容问题，直接 reload 即可
      const waiting = registration && registration.waiting
      if (waiting && typeof waiting.postMessage === 'function') {
        // 兜底：如果仍有 waiting 的 SW，手动发送 SKIP_WAITING 让它立即激活
        waiting.postMessage({ type: 'SKIP_WAITING' })
      }
      setTimeout(() => {
        window.location.reload(true)
      }, 150)
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
